import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-save-confirm-manage-user',
  standalone: true,
  imports: [],
  templateUrl: './save-confirm-manage-user.component.html',
  styleUrl: './save-confirm-manage-user.component.scss'
})
export class SaveConfirmManageUserComponent {

  constructor(
    public dialogRef: MatDialogRef<SaveConfirmManageUserComponent>,
  ){}

  onClose(confirm:string){
    this.dialogRef.close(confirm);
  }
}
